import ToastComponent from '@sdk/common/toast/ToastComponent';

import { NavigationProvider } from '@web/navigation/NavigationProvider';
import { NavigateAction } from '@web/navigation/navigationProvider.types';
import { NewsfeedBridgeState } from '@web/newsfeed/NewsfeedBridgeProvider/newsfeedBridgeProvider.types';
import { NewsfeedBridgeProvider } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';

import { ArticleSearchResults, Props as ArticleSearchResultsProps } from './ArticleSearchResults';

type Props = {
  navigate: NavigateAction;
  newsfeedReactBridge: NewsfeedBridgeState;
} & ArticleSearchResultsProps;

export const ArticleSearchResultsAngular = ({
  navigate,
  newsfeedReactBridge,
  ...searchResultsProps
}: Props) => (
  <NavigationProvider navigate={navigate}>
    <NewsfeedBridgeProvider newsfeedBridge={newsfeedReactBridge}>
      <ArticleSearchResults {...searchResultsProps} />
      <ToastComponent />
    </NewsfeedBridgeProvider>
  </NavigationProvider>
);
